<template>
  <div class="noData">
    <img class="img"
      :src="placeholderImage">
    <span class="text">{{ text }}</span>
    <slot />
  </div>
</template>
<script>
export default {
  name: 'NoData',
  props: {
    placeholderImage: {
      type: String,
      default: require('./images/noData.png')
    },
    text: {
      type: String,
      default: '暂无内容'
    }
  },
  data() {
    return {}
  }
}
</script>
<style lang="less" scoped>
.noData {
  width: 100%;
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: PingFang-SC-Medium, PingFang-SC;
  .img {
    width: 295px;
    height: 183px;
    margin-bottom: 18px;
  }
  .text {
    height: 20px;
    font-size: 14px;
    font-weight: bold;
    color: rgba(116, 118, 125, 1);
    line-height: 20px;
  }
}
</style>
